export class Search {

    constructor(store) {
        
        this.store = store;
        this.container = document.createElement("div");
        this.container.className = 'sectionColumn';
        this.container.id = 'SEARCHCONTAINER';
        this.resultsContainer = document.createElement("div");
        this.resultsContainer.className = this.store.config.isSmall ? 'width-90 height-90 column' : 'width-90 height-90 row';
        this.resultsContainer.id = 'RESULTSCONTAINER';
    }

    render(onSearch = null) {
        this.container.innerHTML = "";
        
        const form = document.createElement("form");
        form.className = "flex column width-90 height-10 justify-center align-center";
        form.id = 'FORMSECTION'
        const wrapper = document.createElement("div");
        wrapper.className = "flex width-90 height-80 padding-top-1 padding-bottom-1 padding-top-left-1 padding-top-right-1 justify-center align-center";
        const input = document.createElement("input");
        input.type = "text";
        input.placeholder = "Keresési szöveg...";
        input.className = "form-input";
        const button = document.createElement("button");
        button.type = "submit";
        button.className = "search-button";
        button.innerHTML = "🔍";
        wrapper.appendChild(input);
        wrapper.appendChild(button);
        form.appendChild(wrapper);
        form.addEventListener("submit", async e => {
            e.preventDefault();
            e.stopPropagation();
            const value = input.value.trim();
            let found = await this.store.datas.searchEngine(value);
            this.store.database.searchResults = found;
            this.renderResults(found);
        });
        this.container.appendChild(form);
        this.container.appendChild(this.resultsContainer);
        return this.container;
        
    }

    renderResults(results) {
        this.resultsContainer.innerHTML = "";
        if(results.users.length > 0){
            const section = document.createElement("div");
            section.className = this.store.config.isSmall ? "width-100 height-50" : "width-50 height-100";
            section.id = 'SEARCHSECTION1'
            const rowContainer = document.createElement("div");
            rowContainer.className = "list-row-container";
            const title = document.createElement("div");
            title.className = "section-title";
            title.textContent = "👤 Kollégák";
            rowContainer.appendChild(title);
            results.users.forEach(item => {
                const row = document.createElement("div");
                row.className = "list-row";
                row.innerHTML = `
                    <div class="flex column width-100 height-100">
                        <div class="row-title">${item.name}</div>
                        <div class="list-row-subtitle">${item.email ?? ""}</div>
                    </div>
                `;
                rowContainer.appendChild(row);
                this.bindItemEvents(row, item);
                section.appendChild(rowContainer);
            });
            this.resultsContainer.appendChild(section);
        }

        if(results.inventory.length > 0){
            const section = document.createElement("div");
            section.className = this.store.config.isSmall ? "width-100 height-50" : "width-50 height-100";
            section.id = 'SEARCHSECTION2'
            const rowContainer = document.createElement("div");
            rowContainer.className = "list-row-container";
            const title = document.createElement("div");
            title.className = "section-title";
            title.textContent = "💻 Eszközök";
            rowContainer.appendChild(title);
            results.inventory.forEach(item => {
                const row = document.createElement("div");
                row.className = "list-row";
                row.innerHTML = `
                    <div class="flex column width-100 height-100">
                        <div class="row-title">${item.category}</div>
                        <div class="list-row-subtitle">${item.barcode ?? ""}</div>
                    </div>
                `;
                rowContainer.appendChild(row);
                this.bindItemEvents(row, item);
                
            });
            section.appendChild(rowContainer);
            this.resultsContainer.appendChild(section);
        }
    }

      bindItemEvents(row, item) {
            row.addEventListener("click", async e => {
            e.stopPropagation();
            let modalType = null;
            
            if (Object.hasOwn(item, 'email')) {
                //A USERFORM NÉZI
                this.store.level.selectedColleague = item
                this.store.level.formType = 'USER';
                modalType = '__SET__'
            }else{
                modalType = 'DEVICE'
                let district = await this.store.datas.findOne('CITIES', 'officeid', item.officeid);
                //AZ INVENTORYFORM NÉZI
                this.store.level.selectedOffice = district.name
                if(item.type === 'IT'){this.store.level.formType = 'IT'
                }else if(item.type === 'FURNITURE'){this.store.level.formType = 'FURNITURE'}
            }
            this.store.modalController.setLayout({layout: "MODALOPENWITHDETAILS", component: modalType, data: item});
        });
    }
}